import { View } from 'react-native'

import { styled } from '~/core/styled'

export const Field = styled(View, theme => {
  return {
    base: {
      gap: theme.spacingStackHalfpulse,
    },
  }
})
